// extracted by mini-css-extract-plugin
export default {"queList":"Questionnaire_queList__GMBrp","uploadList":"Questionnaire_uploadList__o51A0","errorMsg":"Questionnaire_errorMsg__cvPBw"};